import { render, staticRenderFns } from "./MlbTopPlaysTable.vue?vue&type=template&id=0c3d45ed&scoped=true"
import script from "./MlbTopPlaysTable.vue?vue&type=script&lang=js"
export * from "./MlbTopPlaysTable.vue?vue&type=script&lang=js"
import style0 from "./MlbTopPlaysTable.vue?vue&type=style&index=0&id=0c3d45ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3d45ed",
  null
  
)

export default component.exports